var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10357_15293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10357_15293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14V0H3.28571V14H1ZM5.57143 14L17 7L5.57143 0V14Z",
    fill: "#6FCF97"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10357_15293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10357_15293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resumeIcon.12e31ab17ed717a6b421475fa3d6aa40.svg";
export { ForwardRef as ReactComponent };